import { WorkspaceState } from './workspace.type'

export const WorkspaceInitialState: WorkspaceState = {
  tabs: [],
  activeTabId: null,
  activeTabType: null,
  recentlyClosedTabs: [],
}
